




















import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import DataprocessServices, { DpSourceInfo } from '@/services/dataprocess';
import PageMixin from '@/mixins/page-mixin';
import { mixins } from 'vue-class-component';
@Component({
  components: {}
})
export default class RefData extends mixins(PageMixin) {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() dsConfig!: DpSourceInfo;

  dpSrv = new DataprocessServices();

  list: any[] = [];
  @Watch('visible')
  async onVisibleChange() {
    if (!this.syncVisible) return false;
    this.initPage();
    this.getList();
  }

  async getList() {
    this.loading = true;
    this.list = [];
    let columns = '';
    this.dsConfig.sourceDsColumns?.forEach((v: any) => {
      columns = columns + v.columnNameEn + ',';
    });
    let sqlstr = `select ${columns.substring(0, columns.length -1)} from ${this.dsConfig.sourceDsTableName}`;

    let params = {
      sourceId: this.dsConfig.sourceDsId,
      tableName: this.dsConfig.sourceDsTableName,
      sqlquery: sqlstr,
      variables: [],
      pageSize: this.limit,
      pageNo: this.page,
    };

    let res: any = await this.dpSrv.excuteSql(params);
    this.list = res.results;
    if (this.page === 1) {
      this.total = res.totalCount;
    }
    this.loading = false;
  }

  get xWidth() {
    if (this.dsConfig.sourceDsColumns) {
       return 180 * this.dsConfig.sourceDsColumns.length;
    }
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
